import { useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { downloadCsv, errMsg } from "../lib/api";
import { addDays } from "../lib/fmt";
import { Block } from "./Common";

export default function PanelExport({ members, today }) {
  const [from, setFrom] = useState(addDays(today, -29));
  const [to, setTo] = useState(today);
  const [memberId, setMemberId] = useState("");
  const go = async () => {
    try {
      await downloadCsv({ from, to, ...(memberId ? { memberId } : {}) }, `crk-laporan_${from}_${to}${memberId ? `_${memberId}` : ""}.csv`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Block title="Ekspor CSV" testid="panel-export">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="label" htmlFor="exp-from">Dari</label>
          <input id="exp-from" data-testid="export-from" type="date" className="field" value={from} onChange={(e) => setFrom(e.target.value)} />
        </div>
        <div>
          <label className="label" htmlFor="exp-to">Sampai</label>
          <input id="exp-to" data-testid="export-to" type="date" className="field" value={to} onChange={(e) => setTo(e.target.value)} />
        </div>
        <div className="col-span-2">
          <label className="label" htmlFor="exp-member">Anggota (opsional)</label>
          <select id="exp-member" data-testid="export-member" className="field" value={memberId} onChange={(e) => setMemberId(e.target.value)}>
            <option value="">Semua anggota</option>
            {members.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
          </select>
        </div>
      </div>
      <button data-testid="export-download-button" onClick={go} className="btn-primary mt-4"><Download size={16} /> Unduh CSV</button>
      <p className="mt-2 text-xs text-[#7a6667]">Format Excel Indonesia: pemisah titik koma, UTF-8.</p>
    </Block>
  );
}
